module.exports = __webpack_public_path__ + "static/media/sponsorship.007fd057.jpg";